import { Col, Form, Input, Modal, Row, Button, Select } from "antd";
import React, { memo } from "react";
import { useEffect } from "react";
import { PutProjectDescription } from "../../api/APIProjectDescription";
import { useState } from "react";
import { ToastError, ToastSuccess } from "../../components/ToastSwal";

const { Option } = Select;

const ModalEditProjectDescription = ({
  isModalOpenEditProject,
  handleOkEditProject,
  setIsModalOpenEditProject,
  fetchDataProjectDescription,
  ListValueProject,
  idEditProject,
  dataInforProject,
}) => {
  const [form] = Form.useForm();
  
  const [CurrentProjectCode, setCurrentProjectCode] = useState(null);
  const [searchKeywordProjectName, setSearchKeywordProjectName] = useState("");
  
  const [currentProjectStage, setCurrentProjectStage] = useState(null);
  const [searchKeywordProjectStage, setSearchKeywordProjectStage] = useState("");
  
  const [currentPricingModel, setCurrentPricingModel] = useState(null);
  const [searchKeywordPricingModel, setSearchKeywordPricingModel] = useState("");

  const [currentRsvntoRsjp, setCurrentRsvntoRsjp] = useState(null);
  const [searchKeywordRsvntoRsjp, setSearchKeywordRsvntoRsjp] = useState("");

  const [loadings, setLoadings] = useState(false);

  const RsvntoRsjpOptions = [
    { value: 'Yes', label: 'Yes' },
    { value: 'No', label: 'No' },
  ]
  
  const pricingModelOptions = [
    { value: 'Regular unit price', label: 'Regular unit price' },
    { value: 'Separate detail', label: 'Separate detail' },
    { value: 'Monthly fixed fee', label: 'Monthly fixed fee' },
    { value: 'Monthly minimum fee', label: 'Monthly minimum fee' },
  ]

  const projectStageOptions = [
    { value: 'New', label: 'New' },
    { value: 'Waiting', label: 'Waiting' },
    { value: 'On-going', label: 'On-going' },
    { value: 'Close', label: 'Close' },

  ]

  const handleCancelEditProject = () => {
    setIsModalOpenEditProject(false);
    form.resetFields();
  };

  useEffect(() => {
    form.resetFields();
    if (isModalOpenEditProject) {      
      // console.log('dataInforProject', dataInforProject);
      // Set giá trị cho trường rsvn_to_rsjp do API trả về là True/False
      if (dataInforProject.rsvn_to_rsjp === 'True') {
        dataInforProject.rsvn_to_rsjp = 'Yes';
      } else { 
        dataInforProject.rsvn_to_rsjp = 'No';
      }

      form.setFieldsValue({
        project_name: dataInforProject.project_code__project_name,
        project_stage: dataInforProject.projectstage,
        sub_project_name_1: dataInforProject.subprojectname1,
        sub_project_name_2: dataInforProject.subprojectname2,
        project_description: dataInforProject.projectcription,
        pricing_model: dataInforProject.pricingmodels,
        unit_price_total: dataInforProject.unit_price_total,
        rsvn_to_rsjp: dataInforProject.rsvn_to_rsjp,
        rsvn_to_rsjp_unit_price: dataInforProject.rsvn_to_rsjp_unit_price,
      });
    }
  }, [isModalOpenEditProject, dataInforProject, form]);

  const onFinish = (values) => {
    // console.log('values: ', values);
    var FormData = require("form-data");
    var data = new FormData();
    setLoadings(!loadings);

    // Kiểm tra giá trị null/undefined
    var projectCode = CurrentProjectCode ?? dataInforProject.project_code;
    var projectStage = currentProjectStage ?? values.project_stage;
    var pricingModel = currentPricingModel ?? values.pricing_model;
    var rsvnToRsjp = currentRsvntoRsjp ?? values.rsvn_to_rsjp;

    // Loại bỏ giá trị null/undefined và nối chuỗi ko có dấu cách
    var descriptionCode = [
        values.sub_project_name_1,
        values.sub_project_name_2,
        values.project_description
    ].filter(Boolean).join("");

    data.append("id", dataInforProject.id);
    data.append("message", "update");
    data.append("project_code", projectCode);
    data.append("projectstage", projectStage);
    data.append("subprojectname1", values.sub_project_name_1 || "");
    data.append("subprojectname2", values.sub_project_name_2 || "");
    data.append("projectcription", values.project_description || "");
    data.append("description_code", descriptionCode);
    data.append("pricingmodels", pricingModel);
    data.append("unit_price_total", values.unit_price_total);
    data.append("rsvn_to_rsjp", rsvnToRsjp);
    data.append("rsvn_to_rsjp_unit_price", values.rsvn_to_rsjp_unit_price);
    
    // currentDuAn
    PutProjectDescription(data)
      .then((res) => {        
        if (res.data.message === "Description đã tồn tại!") {
          // Không làm gì nếu project đã tồn tại
          ToastError.fire({
            icon: "error",
            title: res.data.message,
          });
          setLoadings(false); // Tắt trạng thái loading của nút Save
          return false; // Thoát khỏi hàm nếu đã tồn tại
        }

        // Nếu không có lỗi, tiếp tục xử lý
        ToastSuccess.fire({
          icon: "success",
          title: "Cập nhật Description thành công",
        });
        setLoadings(false);
        fetchDataProjectDescription();
        handleCancelEditProject();
      })
      .catch((error) => {
        ToastError.fire({
          icon: "error",
          title: error.data.message,
        });
      });
  };

  const onChangeProjectName = (e) => {
    setCurrentProjectCode(e);
  };

  const handleSearchProjectName = (value) => {
    setSearchKeywordProjectName(value);
  };
  
  const onChangeProjectStage = (e) => {
    setCurrentProjectStage(e);
  };

  const handleSearchProjectStage = (value) => {
    setSearchKeywordProjectStage(value);
  };

  const onChangePricingModel = (e) => {
    setCurrentPricingModel(e);
  };

  const handleSearchPricingModel = (value) => {
    setSearchKeywordPricingModel(value);
  };

  const onChangerRsvntoRsjp = (e) => {
    setCurrentRsvntoRsjp(e);
  };

  const handleSearchRsvntoRsjp = (value) => {
    setSearchKeywordRsvntoRsjp(value);
  };

  return (
    <Modal
      title="EDIT PROJECT DESCRIPTION"
      open={isModalOpenEditProject}
      onOk={handleOkEditProject}
      onCancel={handleCancelEditProject}
      footer={false}
      width={800}
      forceRender={true}
      className="headerTitleModal"
    >
      <Form
        form={form}
        layout="vertical"
        autoComplete="off"
        onFinish={onFinish}
        // onFinishFailed={onFinishFailed}
        // validateMessages={validateMessages}
        // loading={loading}
        initialValues={{
          remember: true,
        }}
      >
        <Row>
          <Col span={11}>
            <Form.Item
              label="Project Name"
              name="project_name"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập Project Name!",
                },
              ]}
            >
              <Select
                size="large"
                placeholder="Project Name"
                onChange={onChangeProjectName}
                showSearch
                onSearch={handleSearchProjectName}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                value={searchKeywordProjectName}
              >
                {ListValueProject.map((e) => (
                  <Option key={e.id} value={e.id}>
                    {e.projectname}
                  </Option>
                ))}
                </Select>
            </Form.Item>
          </Col>
          <Col span={2}></Col>
          <Col span={11}>
            <Form.Item
              label="Project Stage"
              name="project_stage"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập Project Stage!",
                },
              ]}
            >
              <Select
                size="large"
                placeholder="Project Stage"
                onChange={onChangeProjectStage}
                showSearch
                onSearch={handleSearchProjectStage}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                value={searchKeywordProjectStage}
              >
                {projectStageOptions.map((e) => (
                  <Option key={e.value} value={e.value}>
                    {e.label}
                  </Option>
                ))}
                </Select>

              
            </Form.Item>
          </Col>
          <Col span={11}>
            <Form.Item
              label="Sub Project Name 1"
              name="sub_project_name_1"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập Sub Project Name 1!",
                },
              ]}
            >
              <Input size="large" placeholder="Sub Project Name 1" />
            </Form.Item>
          </Col>
          <Col span={2}></Col>
          <Col span={11}>
            <Form.Item
              label="Sub Project Name 2"
              name="sub_project_name_2"
              rules={[
                {
                  message: "Vui lòng nhập Sub Project Name 2!",
                },
              ]}
            >
              <Input size="large" placeholder="Sub Project Name 2" />
            </Form.Item>
          </Col>
          <Col span={11}>
            <Form.Item
              label="Project Description"
              name="project_description"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập Project Description!",
                },
              ]}
            >
              <Input size="large" placeholder="Project Description" />
            </Form.Item>
          </Col>
          <Col span={2}></Col>
          <Col span={11}>
            <Form.Item
              label="Pricing Model"
              name="pricing_model"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập Pricing Model!",
                },
              ]}
            >
              <Select
                size="large"
                placeholder="Pricing Model"
                onChange={onChangePricingModel}
                showSearch
                onSearch={handleSearchPricingModel}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                value={searchKeywordPricingModel}
              >
                {pricingModelOptions.map((e) => (
                  <Option key={e.value} value={e.value}>
                    {e.label}
                  </Option>
                ))}
                </Select>
            </Form.Item>
          </Col>
          <Col span={11}>
            <Form.Item
              label="Unit Price Total"
              name="unit_price_total"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập Unit Price Total!",
                },
                {
                  pattern: /^[0-9]+(\.[0-9]+)?$/,
                  message: "Unit Price Total chỉ nhập số hoặc số thập phân!",
                }
              ]}
            >
              <Input size="large" placeholder="Unit Price Total" />
            </Form.Item>
          </Col>
          <Col span={2}></Col>
          <Col span={11}>
            <Form.Item
              label="RSVN to RSJP"
              name="rsvn_to_rsjp"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập RSVN to RSJP!",
                },
              ]}
            >
              <Select
                size="large"
                placeholder="RSVN to RSJP"
                onChange={onChangerRsvntoRsjp}
                showSearch
                onSearch={handleSearchRsvntoRsjp}
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                value={searchKeywordRsvntoRsjp}
              >
                {RsvntoRsjpOptions.map((e) => (
                  <Option key={e.value} value={e.value}>
                    {e.label}
                  </Option>
                ))}
                </Select>
            </Form.Item>
          </Col>
          <Col span={11}>
            <Form.Item
              label="RSVN to RSJP Unit Price"
              name="rsvn_to_rsjp_unit_price"
              rules={[
                {
                  required: true,
                  message: "Vui lòng nhập RSVN to RSJP Unit Price!",
                },
                {
                  pattern: /^[0-9]+(\.[0-9]+)?$/,
                  message: "RSVN to RSJP chỉ nhập số hoặc số thập phân!",
                }
              ]}
            >
              <Input size="large" placeholder="RSVN to RSJP Unit Price" />
            </Form.Item>
          </Col>
          <Col span={2}></Col>

          <Col span={24} style={{ textAlign: "center" }}>
            <Button
              className="btnSaveModel"
              type="success"
              htmlType="submit"
              variant="contained"
              loading={loadings}
            >
              Update
            </Button>
            <Button
              className="btnCancelModel"
              variant="outlined"
              onClick={handleCancelEditProject}
            >
              Cancel
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default memo(ModalEditProjectDescription);
